import { Pipe, PipeTransform } from '@angular/core';
import { DocumentTypeGroupEnum } from '../../default-constants/document-type-settings.constants';

@Pipe({
  name: 'addDocumentTypeButtonName',
  standalone: true
})
export class AddDocumentTypeButtonNamePipe implements PipeTransform {

  private addFieldButtonTextKeys ={
    [DocumentTypeGroupEnum.TopSection]: "Document type setting - modal - document section (Document type section) - Add Index Field",
    [DocumentTypeGroupEnum.DocumentField]: "Document type setting - modal - add document fields section (Document type section) - Add Pin Fields",
    [DocumentTypeGroupEnum.Overview]: "Document type setting - modal - add document fields section (Document type section) - Add meta data",
  }

  transform(value: string, fallbackKey?:string): string {
    return Object.prototype.hasOwnProperty.call(this.addFieldButtonTextKeys, value) 
      ? this.addFieldButtonTextKeys[value as DocumentTypeGroupEnum] 
      : (fallbackKey ?? value);
  }

}
